<template>
  <div class="myDocument" style="background-color: #f5f5f5 !important; width: auto; min-height: 100%;">
    <Navbar />
    <!-- <v-content> -->
      <!-- <h1>{{ titulo }}</h1> -->
      <!-- <DocumentList /> -->
      <!-- <EndDocument /> -->
      <router-view :key="$route.path" />
    <!-- </v-content> -->
  </div>
</template>

<script>
// @ is an alias to /src
import Navbar from '@/components/Navbar.vue'
/* import DocumentList from '@/components/tramites/DocumentList.vue' */
/* import EndDocument from '@/components/tramites/EndDocument.vue' */

export default {
  name: 'MyDocument',
  components: {
    /* DocumentList, */ /* EndDocument, */
    Navbar
  },
  data () {
    return {
      titulo: 'Mis Trámites'
    }
  }
}
</script>
